module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "head-user",
    attrs: {
      "to": "/main"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "service"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "service-cards"
  }, _vm._l((_vm.serverList), function(item) {
    return _c('div', {
      staticClass: "service-card"
    }, [_c('div', {
      staticClass: "product-card"
    }, [_c('div', {
      staticClass: "pkg-card"
    }, [_c('div', {
      staticClass: "pkg-title"
    }, [_c('p', {
      staticClass: "cardtitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "detail"
    }, [_vm._v(_vm._s(item.explain))])]), _vm._v(" "), _c('div', {
      staticClass: "pkg-detail"
    }, [_c('div', {
      staticClass: "dropdown-form"
    }, [_c('div', {
      staticClass: "dropdown dropdown-render"
    }, [_c('div', {
      staticClass: "dropdown-name"
    }, [_vm._v("CPU")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-value"
    }, [_vm._v(_vm._s(item.cpu) + "G")])])]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-form"
    }, [_c('div', {
      staticClass: "dropdown dropdown-render"
    }, [_c('div', {
      staticClass: "dropdown-name"
    }, [_vm._v("内存")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-value"
    }, [_vm._v(_vm._s(item.ram) + "G")])])]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-form"
    }, [_c('div', {
      staticClass: "dropdown dropdown-render"
    }, [_c('div', {
      staticClass: "dropdown-name"
    }, [_vm._v("带宽")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-value"
    }, [_vm._v(_vm._s(item.NET_WIDTH) + "M")])])]), _vm._v(" "), _c('div', {
      staticClass: "border"
    }), _vm._v(" "), _c('div', {
      staticClass: "pkg-order"
    }, [_c('div', {
      staticClass: "price"
    }, [_c('p', {
      staticClass: "discount-price"
    }, [_vm._v("\n                      " + _vm._s(item.price) + "元 /\n                      "), (item.p_time == 1) ? _c('span', [_vm._v("首月")]) : _vm._e(), _vm._v(" "), (item.p_time == 12) ? _c('span', [_vm._v("1年")]) : _vm._e(), _vm._v(" "), (item.p_time == 24) ? _c('span', [_vm._v("2年")]) : _vm._e()])]), _vm._v(" "), _c('a', {
      staticClass: "btn-red",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.buy(item.id)
        }
      }
    }, [_vm._v("立即购买")])])])])])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "title-out"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v("云服务器专区")])]), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_c('p', {
    staticClass: "explain-text"
  }, [_vm._v("暑假大促销，性价比最高")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c443af3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/act.vue
// module id = Azjp
// module chunks = 1